



















import { Vue, Component, Prop } from "vue-property-decorator";
import { ProjectNote } from "@/data/models/ProjectNote";
import { formatDateAndTime } from "@/utils/DateFormatter";
import { findNickname } from "@/data/repository/UserRepository";

@Component
export default class ProjectNoteItem extends Vue {
  @Prop()
  projectNote!: ProjectNote;

  get createdBy() {
    return (
      formatDateAndTime(
        this.projectNote.createdBy.recordedAt,
        this.projectNote.createdBy.recordedAt
      ) +
      ", " +
      findNickname(this.projectNote.createdBy.recordedByUserId)
    );
  }

  onEditNote() {
    this.$emit("editNote", this.projectNote);
  }

  get noteText() {
    return this.projectNote.note;
  }

  get recipients() {
    return this.projectNote.note;
  }
}
